/* @flow */

export const ActionTypes = {
    ANALYTICS_MODAL_CLOSED: 'ANALYTICS_MODAL_CLOSED',
    ANALYTICS_MODAL_OPENED: 'ANALYTICS_MODAL_OPENED',
};

type AnalyticsModalClosedAction = {type: 'ANALYTICS_MODAL_CLOSED'};
type AnalyticsModalOpenedAction = {
    type: 'ANALYTICS_MODAL_OPENED',
};

export type AnalyticsModalAction = AnalyticsModalOpenedAction | AnalyticsModalClosedAction;

/*
 * Action creators
 */
export const closeAnalyticsModal = (): AnalyticsModalClosedAction => ({
    type: ActionTypes.ANALYTICS_MODAL_CLOSED,
});

export const openAnalyticsModal = (): AnalyticsModalOpenedAction => ({
    type: ActionTypes.ANALYTICS_MODAL_OPENED,
});
